import React from 'react'
import { Box, Typography, Chip } from '@mui/material'
import { InventoryInspectionDetail } from './types'

interface InventoryIssueCardProps {
    inventoryInspection: InventoryInspectionDetail
    areaName?: string
}

export const InventoryIssueCard: React.FC<InventoryIssueCardProps> = ({
    inventoryInspection,
    areaName,
}) => {
    return (
        <Box
            sx={{
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: 2,
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.04)',
                    px: 2,
                    py: 1.5,
                }}
            >
                <Box>
                    <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: '#fff' }}
                    >
                        {inventoryInspection.name}
                    </Typography>
                    {areaName && (
                        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                            {areaName}
                        </Typography>
                    )}
                </Box>
                {inventoryInspection.status && (
                    <Chip
                        label={inventoryInspection.status}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            color: '#94a3b8',
                            fontWeight: 600,
                            fontSize: '0.7rem',
                        }}
                    />
                )}
            </Box>

            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {(inventoryInspection.issues ?? []).length === 0 && (
                    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                        No issues reported
                    </Typography>
                )}

                {(inventoryInspection.issues ?? []).map((issue) => (
                    <Box key={issue.id}>
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 500, color: '#e2e8f0', mb: 0.5 }}
                        >
                            {issue.config_name}
                        </Typography>
                        {issue.description && (
                            <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                                {issue.description}
                            </Typography>
                        )}
                        {(issue.attachments ?? []).length > 0 && (
                            <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                                {issue.attachments.map((att) => (
                                    <Box
                                        key={att.id}
                                        component="img"
                                        src={att.url}
                                        sx={{
                                            width: 64,
                                            height: 64,
                                            borderRadius: 1,
                                            objectFit: 'cover',
                                            border: '1px solid rgba(255, 255, 255, 0.1)',
                                        }}
                                    />
                                ))}
                            </Box>
                        )}
                    </Box>
                ))}

                {(inventoryInspection.attachments ?? []).length > 0 && (
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {inventoryInspection.attachments.map((att) => (
                            <Box
                                key={att.id}
                                component="img"
                                src={att.url}
                                sx={{
                                    width: 64,
                                    height: 64,
                                    borderRadius: 1,
                                    objectFit: 'cover',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                }}
                            />
                        ))}
                    </Box>
                )}

                {inventoryInspection.note && (
                    <Box
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: 1,
                            p: 1.5,
                            mt: 0.5,
                        }}
                    >
                        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                            Note: {inventoryInspection.note}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    )
}
